import FormattedMessage from 'I18n/components/FormattedMessage';
import GoToActionFlowViewContent from 'automation-ui-canvas/containers/flow-views/go-to-action/GoToActionFlowViewContent';
import { GO_TO_ACTION_FLOW_VIEW_TEST } from 'automation-ui-canvas/constants/Gates';
import useGetGoToActionFlowData from 'automation-ui-canvas/containers/flow-views/go-to-action/useGetGoToActionFlowData';
import { generatePath } from 'react-router-dom';
import { CANVAS_ROOT } from 'automation-ui-canvas/constants/AbsolutePaths';
import { GO_TO_ACTION_FLOW_VIEW } from 'automation-ui-canvas/containers/flow-views/flowViewIds';
import { jsx as _jsx } from "react/jsx-runtime";
const GoToActionFlowViewConfig = {
  id: GO_TO_ACTION_FLOW_VIEW,
  getIsAvailable: ({
    getIsUngated
  }) => getIsUngated(GO_TO_ACTION_FLOW_VIEW_TEST),
  useGetViewData: useGetGoToActionFlowData,
  modeIndicator: {
    use: 'preview',
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation.goToEditCanvas.header"
    })
  },
  ContentComponent: GoToActionFlowViewContent,
  onCancel: (history, flowId) => {
    history.push({
      pathname: generatePath(CANVAS_ROOT, {
        screen: 'edit',
        flowId
      }),
      search: ''
    });
  }
};
export default GoToActionFlowViewConfig;